import React from 'react';
import { FormGroup } from 'reactstrap';
import PromoDateField from './PromoDateField';

const EarlyStartEndDatePicker = ({
  // special
  handleSpecialStartDate,
  handleSpecialEndDate,
  datePickerSpecialStartDate,
  datePickerSpecialEndDate,
  specialStartDate,
  specialEndDate,

  // early
  handleEarlyStartDate,
  handleEarlyEndDate,
  datePickerEarlyStartDate,
  datePickerEarlyEndDate,
  earlyStartDate,
  earlyEndDate,

  // term
  handleTermStartDate,
  handleTermEndDate,
  handleTerm2StartDate,
  handleTerm2EndDate,
  datePickerTermStartDate,
  datePickerTermEndDate,
  datePickerTerm2StartDate,
  datePickerTerm2EndDate,
  termStartDate,
  termEndDate,
  term2StartDate,
  term2EndDate,

  // normal promo
  handleNormalPromoStartDate,
  handleNormalPromoEndDate,
  datePickerNormalPromoStartDate,
  datePickerNormalPromoEndDate,
  normalPromoStartDate,
  normalPromoEndDate,

  // corporate sale
  handleCorporateSaleStartDate,
  handleCorporateSaleEndDate,
  corporateSaleStartDate,
  corporateSaleEndDate,
  datePickerCorporateSaleStartDate,
  datePickerCorporateSaleEndDate,

  // sale
  handleSaleEndDate,
  datePickerSaleEndDate,
  saleEndDate,

  // date picker
  openDatePicker,
  closeDatePicker,
}) => {
  // [startField, endField, labelPrefix, htmlForPrefix] per linked range
  const linkedRanges = [
    {
      key: 'Special',
      labels: ['Special Price Start Date', 'Special Price End Date'],
      htmlFors: ['formSpecialStartDate', 'formSpecialEndDate'],
      pickerKeys: ['datePickerSpecialStartDate', 'datePickerSpecialEndDate'],
      opens: [datePickerSpecialStartDate, datePickerSpecialEndDate],
      fields: [specialStartDate, specialEndDate],
      handlers: [handleSpecialStartDate, handleSpecialEndDate],
    },
    {
      key: 'Early',
      labels: ['Early Bird Start Date', 'Early Bird End Date'],
      htmlFors: ['formEarlyStartDate', 'formEarlyEndDate'],
      pickerKeys: ['datePickerEarlyStartDate', 'datePickerEarlyEndDate'],
      opens: [datePickerEarlyStartDate, datePickerEarlyEndDate],
      fields: [earlyStartDate, earlyEndDate],
      handlers: [handleEarlyStartDate, handleEarlyEndDate],
    },
    {
      key: 'Term',
      labels: ['Term Start Date', 'Term End Date'],
      htmlFors: ['formTermStartDate', 'formTermEndDate'],
      pickerKeys: ['datePickerTermStartDate', 'datePickerTermEndDate'],
      opens: [datePickerTermStartDate, datePickerTermEndDate],
      fields: [termStartDate, termEndDate],
      handlers: [handleTermStartDate, handleTermEndDate],
    },
    {
      key: 'Term2',
      labels: ['Term 2 Start Date', 'Term 2 End Date'],
      htmlFors: ['formTerm2StartDate', 'formTerm2EndDate'],
      pickerKeys: ['datePickerTerm2StartDate', 'datePickerTerm2EndDate'],
      opens: [datePickerTerm2StartDate, datePickerTerm2EndDate],
      fields: [term2StartDate, term2EndDate],
      handlers: [handleTerm2StartDate, handleTerm2EndDate],
    },
    {
      key: 'NormalPromo',
      labels: ['Normal Promo Start Date', 'Normal Promo End Date'],
      htmlFors: ['formNormalPromoStartDate', 'formNormalPromoEndDate'],
      pickerKeys: [
        'datePickerNormalPromoStartDate',
        'datePickerNormalPromoEndDate',
      ],
      opens: [datePickerNormalPromoStartDate, datePickerNormalPromoEndDate],
      fields: [normalPromoStartDate, normalPromoEndDate],
      handlers: [handleNormalPromoStartDate, handleNormalPromoEndDate],
    },
  ];

  return (
    <>
      {linkedRanges.map((range) => (
        <FormGroup key={range.key} className="d-flex justify-content-around">
          <PromoDateField
            label={range.labels[0]}
            htmlFor={range.htmlFors[0]}
            field={range.fields[0]}
            open={range.opens[0]}
            onOpen={() => openDatePicker(range.pickerKeys[0])}
            onClose={() => closeDatePicker(range.pickerKeys[0])}
            onChange={range.handlers[0]}
            selectsStart
            startDate={range.fields[0].value}
            endDate={range.fields[1].value}
            isClearable
          />
          <PromoDateField
            label={range.labels[1]}
            htmlFor={range.htmlFors[1]}
            field={range.fields[1]}
            open={range.opens[1]}
            onOpen={() => openDatePicker(range.pickerKeys[1])}
            onClose={() => closeDatePicker(range.pickerKeys[1])}
            onChange={range.handlers[1]}
            selectsEnd
            startDate={range.fields[0].value}
            endDate={range.fields[1].value}
            isClearable
          />
        </FormGroup>
      ))}

      <FormGroup className="d-flex justify-content-around">
        <PromoDateField
          label="Sale End Date"
          htmlFor="formSaleEndDate"
          field={saleEndDate}
          open={datePickerSaleEndDate}
          onOpen={() => openDatePicker('datePickerSaleEndDate')}
          onClose={() => closeDatePicker('datePickerSaleEndDate')}
          onChange={handleSaleEndDate}
        />
      </FormGroup>

      <FormGroup className="d-flex justify-content-around">
        <PromoDateField
          label="Corporate Sale Start Date"
          htmlFor="formTermStartDate"
          field={corporateSaleStartDate}
          open={datePickerCorporateSaleStartDate}
          onOpen={() => openDatePicker('datePickerCorporateSaleStartDate')}
          onClose={() => closeDatePicker('datePickerCorporateSaleStartDate')}
          onChange={handleCorporateSaleStartDate}
          isClearable
        />
        <PromoDateField
          label="Corporate Sale End Date"
          htmlFor="formTermEndDate"
          field={corporateSaleEndDate}
          open={datePickerCorporateSaleEndDate}
          onOpen={() => openDatePicker('datePickerCorporateSaleEndDate')}
          onClose={() => closeDatePicker('datePickerCorporateSaleEndDate')}
          onChange={handleCorporateSaleEndDate}
          isClearable
        />
      </FormGroup>
    </>
  );
};

export default EarlyStartEndDatePicker;
